import React, { useEffect, useMemo, useState } from "react";
import axios from "../import/axiosConfig";
import Swal from "sweetalert2";

const PAGE_STYLE_ID = "payment-verification-inline-css";

const injectPageStyles = () => {
  if (document.getElementById(PAGE_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = PAGE_STYLE_ID;
  style.innerHTML = `
    .pv-page {
      padding: 20px;
      background: #f6f8fb;
      min-height: 100vh;
    }

    .pv-card {
      background: #fff;
      border-radius: 18px;
      box-shadow: 0 10px 30px rgba(16, 24, 40, 0.08);
      border: 1px solid #e8edf4;
      overflow: hidden;
    }

    .pv-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      padding: 18px 20px;
      border-bottom: 1px solid #edf1f7;
      flex-wrap: wrap;
    }

    .pv-title {
      margin: 0;
      font-size: 24px;
      font-weight: 800;
      color: #14213d;
    }

    .pv-subtitle {
      margin-top: 4px;
      font-size: 13px;
      color: #667085;
    }

    .pv-toolbar {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      align-items: center;
    }

    .pv-search,
    .pv-select {
      height: 38px;
      border: 1px solid #d0d7e2;
      border-radius: 10px;
      padding: 0 12px;
      outline: none;
      background: #fff;
      min-width: 180px;
    }

    .pv-counter {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 8px 12px;
      border-radius: 999px;
      background: #eef4ff;
      color: #155eef;
      font-size: 13px;
      font-weight: 700;
    }

    .pv-table-wrap {
      width: 100%;
      overflow: auto;
    }

    .pv-table {
      width: 100%;
      min-width: 1540px;
      border-collapse: separate;
      border-spacing: 0;
    }

    .pv-table thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: #f8fafc;
      color: #475467;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      padding: 14px 12px;
      border-bottom: 1px solid #e5e7eb;
      text-align: left;
      white-space: nowrap;
    }

    .pv-table tbody td {
      padding: 14px 12px;
      border-bottom: 1px solid #edf1f7;
      vertical-align: middle;
      font-size: 14px;
      color: #101828;
      background: #fff;
    }

    .pv-table tbody tr:hover td {
      background: #fafcff;
    }

    .pv-strong {
      font-weight: 700;
      color: #14213d;
    }

    .pv-muted {
      font-size: 12px;
      color: #667085;
      margin-top: 4px;
    }

    .pv-amount {
      font-weight: 800;
      color: #067647;
    }

    .pv-box {
      min-width: 180px;
      border: 1px solid #d0d7e2;
      background: #f8fafc;
      border-radius: 10px;
      padding: 10px;
      font-size: 13px;
      line-height: 1.5;
      color: #344054;
      white-space: pre-wrap;
      word-break: break-word;
    }

    .pv-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 92px;
      padding: 6px 10px;
      border-radius: 999px;
      font-size: 12px;
      font-weight: 700;
      text-transform: capitalize;
      border: 1px solid transparent;
    }

    .pv-badge.pending {
      background: #fff7e6;
      color: #b54708;
      border-color: #fedf89;
    }

    .pv-badge.completed {
      background: #eef4ff;
      color: #155eef;
      border-color: #b2ddff;
    }

    .pv-badge.approved {
      background: #ecfdf3;
      color: #067647;
      border-color: #abefc6;
    }

    .pv-badge.rejected {
      background: #fef3f2;
      color: #b42318;
      border-color: #fecdca;
    }

    .pv-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .pv-btn {
      border: none;
      border-radius: 10px;
      padding: 8px 12px;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
      transition: 0.2s ease;
      white-space: nowrap;
    }

    .pv-btn:hover {
      transform: translateY(-1px);
      opacity: 0.95;
    }

    .pv-btn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    .pv-btn.verify {
      background: #16a34a;
      color: #fff;
    }

    .pv-btn.hold {
      background: #7c3aed;
      color: #fff;
    }

    .pv-btn.reject {
      background: #dc2626;
      color: #fff;
    }

    .pv-btn.delete {
      background: #344054;
      color: #fff;
    }

    .pv-btn.refresh {
      background: #155eef;
      color: #fff;
      height: 38px;
      padding: 0 16px;
    }

    .pv-empty {
      padding: 40px 20px;
      text-align: center;
      color: #667085;
      font-size: 14px;
    }

    .pv-modal-overlay {
      position: fixed;
      inset: 0;
      background: rgba(15, 23, 42, 0.45);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      padding: 18px;
    }

    .pv-modal {
      width: 100%;
      max-width: 700px;
      background: #fff;
      border-radius: 18px;
      box-shadow: 0 20px 50px rgba(0,0,0,0.18);
      overflow: hidden;
    }

    .pv-modal-head {
      padding: 18px 20px;
      border-bottom: 1px solid #edf1f7;
    }

    .pv-modal-head h3 {
      margin: 0;
      font-size: 20px;
      font-weight: 700;
      color: #14213d;
    }

    .pv-modal-body {
      padding: 20px;
    }

    .pv-info-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
      margin-bottom: 16px;
    }

    .pv-info-card {
      padding: 12px;
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      background: #f8fafc;
    }

    .pv-info-label {
      font-size: 12px;
      color: #667085;
      margin-bottom: 4px;
    }

    .pv-info-value {
      font-size: 14px;
      font-weight: 700;
      color: #101828;
      word-break: break-word;
    }

    .pv-label {
      display: block;
      font-size: 13px;
      font-weight: 700;
      color: #344054;
      margin-bottom: 8px;
    }

    .pv-textarea {
      width: 100%;
      min-height: 140px;
      resize: vertical;
      border: 1px solid #d0d7e2;
      border-radius: 12px;
      padding: 12px;
      outline: none;
      font-size: 14px;
      color: #101828;
      background: #fff;
    }

    .pv-modal-foot {
      padding: 16px 20px 20px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }

    .pv-btn-light {
      background: #eef2f6;
      color: #344054;
    }

    @media (max-width: 768px) {
      .pv-info-grid {
        grid-template-columns: 1fr;
      }
    }
  `;
  document.head.appendChild(style);
};

const toText = (v) => (v === null || v === undefined ? "" : String(v));

const PaymentVerification = () => {
  const [transactions, setTransactions] = useState([]);
  const [customerNameMap, setCustomerNameMap] = useState({});
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [loading, setLoading] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState("");
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [verificationText, setVerificationText] = useState("");

  useEffect(() => {
    injectPageStyles();
    fetchPaymentDetails();
  }, []);

  const getDatabase = () => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    return userData?.database || "";
  };

  const extractCustomerName = (res) => {
    return (
      res?.data?.Customer?.CompanyName ||
      res?.data?.customer?.CompanyName ||
      res?.data?.data?.CompanyName ||
      res?.data?.CompanyName ||
      "-"
    );
  };

  const fetchCustomerNames = async (rows = []) => {
    try {
      const ids = [...new Set(rows.map((x) => x?.partyId).filter(Boolean))];
      if (!ids.length) {
        setCustomerNameMap({});
        return;
      }

      const results = await Promise.all(
        ids.map(async (id) => {
          try {
            const res = await axios.get(`/customer/view-customer-by-id/${id}`);
            return [id, extractCustomerName(res)];
          } catch (error) {
            console.log("customer fetch error", id, error);
            return [id, "-"];
          }
        }),
      );

      setCustomerNameMap(Object.fromEntries(results));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPaymentDetails = async () => {
    try {
      setLoading(true);
      const database = getDatabase();

      if (!database) {
        Swal.fire({
          icon: "warning",
          title: "Database Missing",
          text: "User database not found in localStorage.",
        });
        setTransactions([]);
        setCustomerNameMap({});
        return;
      }
      const user = JSON.parse(localStorage.getItem("userData") || "{}");
      const financialYearSelected = localStorage.getItem(
        "financialYearSelected",
      );
      const selectedDatabase = `${user?.database}-${financialYearSelected}`;

      const res = await axios.get(
        `/order/view-payment-details/${selectedDatabase}`,
      );
      let data = res?.data?.paymentDetails || [];

      data.sort((a, b) => {
        const scanA = new Date(
          `${a?.paymentDetails?.scanDate || a?.paymentDetails?.date || a?.Date || ""} ${a?.paymentDetails?.scanTime || a?.paymentDetails?.time || a?.Time || ""}`,
        );
        const scanB = new Date(
          `${b?.paymentDetails?.scanDate || b?.paymentDetails?.date || b?.Date || ""} ${b?.paymentDetails?.scanTime || b?.paymentDetails?.time || b?.Time || ""}`,
        );
        return scanB - scanA;
      });

      setTransactions(data);
      fetchCustomerNames(data);
    } catch (error) {
      console.log(error);
      setTransactions([]);
      setCustomerNameMap({});
    } finally {
      setLoading(false);
    }
  };

  const getStatusClass = (status) => {
    const value = toText(status).toLowerCase();
    if (value === "approved") return "approved";
    if (value === "completed") return "completed";
    if (value === "rejected") return "rejected";
    return "pending";
  };

  const getPartyName = (item) => {
    return customerNameMap[item?.partyId] || item?.partyId || "-";
  };

  const getScannedDate = (item) => {
    return (
      item?.paymentDetails?.scanDate ||
      item?.paymentDetails?.date ||
      item?.Date ||
      "-"
    );
  };

  const getScannedTime = (item) => {
    return (
      item?.paymentDetails?.scanTime ||
      item?.paymentDetails?.time ||
      item?.Time ||
      "-"
    );
  };

  const getScannedDetailsText = (item) => {
    const scanDate = getScannedDate(item);
    const scanTime = getScannedTime(item);
    return `Date: ${scanDate}\nTime: ${scanTime}`;
  };

  const getVerifyRemark = (item) => {
    return (
      item?.paymentDetails?.verifyRemark || item?.paymentDetails?.remark || ""
    );
  };

  const filteredTransactions = useMemo(() => {
    return transactions.filter((item) => {
      const term = searchText.trim().toLowerCase();
      const currentStatus = toText(item?.statusQr).toLowerCase();

      const matchesSearch =
        !term ||
        toText(getPartyName(item)).toLowerCase().includes(term) ||
        toText(item?.partyId).toLowerCase().includes(term) ||
        toText(item?.invoiceId).toLowerCase().includes(term) ||
        toText(getScannedDate(item)).toLowerCase().includes(term) ||
        toText(item?.accountNumber).toLowerCase().includes(term) ||
        toText(item?.bankIFSC).toLowerCase().includes(term);

      const matchesStatus =
        statusFilter === "ALL" || currentStatus === statusFilter.toLowerCase();

      return matchesSearch && matchesStatus;
    });
  }, [transactions, searchText, statusFilter, customerNameMap]);

  const openVerifyModal = (item) => {
    setSelectedItem(item);
    setVerificationText(getVerifyRemark(item));
    setShowVerifyModal(true);
  };

  const closeVerifyModal = () => {
    setShowVerifyModal(false);
    setSelectedItem(null);
    setVerificationText("");
  };

  const handleVerifySubmit = async () => {
    try {
      if (!selectedItem?._id) return;

      if (!verificationText.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Details Required",
          text: "Please enter bank / transaction / UTR details.",
        });
        return;
      }

      setActionLoadingId(selectedItem._id);

      const existingDetails = selectedItem?.paymentDetails || {};
      const now = new Date();

      const extractedUtr =
        verificationText.match(/\d{10,18}/)?.[0] ||
        existingDetails?.utrNumber ||
        "";

      const mergedPaymentDetails = {
        ...existingDetails,
        scanDate:
          existingDetails?.scanDate ||
          existingDetails?.date ||
          selectedItem?.Date ||
          now.toLocaleDateString("en-IN"),
        scanTime:
          existingDetails?.scanTime ||
          existingDetails?.time ||
          selectedItem?.Time ||
          now.toLocaleTimeString("en-IN"),
        verifyRemark: verificationText.trim(),
        utrNumber: extractedUtr,
        accountNumber: selectedItem?.accountNumber || "",
        bankIFSC: selectedItem?.bankIFSC || "",
        bankDetails: selectedItem?.bankDetails || "",
        verifiedAtDate: now.toLocaleDateString("en-IN"),
        verifiedAtTime: now.toLocaleTimeString("en-IN"),
      };

      Swal.fire({
        title: "Verifying Payment...",
        text: "Saving details and creating receipt",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await axios.post("/order/qrcode-payment", {
        id: selectedItem._id,
        paymentDetails: mergedPaymentDetails,
      });

      await axios.post("/order/final-verification", {
        id: selectedItem._id,
        paymentVerified: true,
      });

      Swal.fire({
        icon: "success",
        title: "Payment Verified ✅",
        text: "Receipt created successfully.",
        timer: 1700,
        showConfirmButton: false,
      });

      closeVerifyModal();
      fetchPaymentDetails();
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: error?.response?.data?.message || "Unable to verify payment.",
      });
    } finally {
      setActionLoadingId("");
    }
  };

  const handleReject = async (item) => {
    try {
      const result = await Swal.fire({
        icon: "warning",
        title: "Reject Payment?",
        text: `Reject invoice ${item?.invoiceId || ""}?`,
        showCancelButton: true,
        confirmButtonText: "Yes, Reject",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#dc2626",
      });

      if (!result.isConfirmed) return;

      setActionLoadingId(item?._id);

      await axios.post("/order/final-verification", {
        id: item?._id,
        paymentVerified: false,
      });

      Swal.fire({
        icon: "success",
        title: "Rejected",
        text: "Payment marked as rejected.",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchPaymentDetails();
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Reject Failed",
        text: error?.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setActionLoadingId("");
    }
  };

  const handleHold = async () => {
    Swal.fire({
      icon: "info",
      title: "Hold API Not Available",
      text: "Hold button is shown, but no backend Hold API was shared yet.",
    });
  };

  const handleDelete = async () => {
    Swal.fire({
      icon: "info",
      title: "Delete API Not Available",
      text: "Delete button is shown, but no backend Delete API was shared yet.",
    });
  };

  return (
    <div className="pv-page">
      <div className="pv-card">
        <div className="pv-header">
          <div>
            <h2 className="pv-title">Payment Verification</h2>
            <div className="pv-subtitle">
              Scanned payment requests, scanned date/time, bank account details,
              verification remarks, and final approval.
            </div>
          </div>

          <div className="pv-toolbar">
            <div className="pv-counter">
              Total: {filteredTransactions.length}
            </div>

            <input
              className="pv-search"
              type="text"
              placeholder="Search party / invoice / bank / date"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            <select
              className="pv-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="ALL">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>

            <button
              className="pv-btn refresh"
              onClick={fetchPaymentDetails}
              disabled={loading}
            >
              {loading ? "Refreshing..." : "Refresh"}
            </button>
          </div>
        </div>

        <div className="pv-table-wrap">
          <table className="pv-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Party Name</th>
                <th>Party ID</th>
                <th>Invoice No</th>
                <th>Amount</th>
                <th>Bank Account</th>
                <th>Scanned Details</th>
                <th>Transaction Details</th>
                <th>Status</th>
                <th style={{ minWidth: "290px" }}>Action</th>
              </tr>
            </thead>

            <tbody>
              {!loading && filteredTransactions.length === 0 ? (
                <tr>
                  <td colSpan="10">
                    <div className="pv-empty">No payment records found.</div>
                  </td>
                </tr>
              ) : (
                filteredTransactions.map((item, index) => {
                  const isApproved =
                    toText(item?.statusQr).toLowerCase() === "approved" ||
                    item?.paymentVerified === true;

                  return (
                    <tr key={item?._id || index}>
                      <td>{index + 1}</td>

                      <td>
                        <div className="pv-strong">{getPartyName(item)}</div>
                      </td>

                      <td>{item?.partyId || "-"}</td>

                      <td>
                        <div className="pv-strong">
                          {item?.invoiceId || "-"}
                        </div>
                        <div className="pv-muted">
                          QR ID: {item?._id || "-"}
                        </div>
                      </td>

                      <td className="pv-amount">
                        ₹{" "}
                        {Number(item?.paidAmounts || 0).toLocaleString("en-IN")}
                      </td>

                      <td>
                        <div className="pv-box">
                          {`Account No: ${item?.accountNumber || "-"}\nIFSC: ${item?.bankIFSC || "-"}`}
                        </div>
                      </td>

                      <td>
                        <div className="pv-box">
                          {getScannedDetailsText(item)}
                        </div>
                      </td>

                      <td>
                        <div className="pv-box">
                          {getVerifyRemark(item) ||
                            "No verification details added yet"}
                        </div>
                      </td>

                      <td>
                        <span
                          className={`pv-badge ${getStatusClass(item?.statusQr)}`}
                        >
                          {item?.statusQr || "Pending"}
                        </span>
                        <div className="pv-muted">
                          {item?.paymentVerified ? "Verified" : "Not Verified"}
                        </div>
                      </td>

                      <td>
                        <div className="pv-actions">
                          <button
                            className="pv-btn verify"
                            onClick={() => openVerifyModal(item)}
                            disabled={
                              actionLoadingId === item?._id || isApproved
                            }
                          >
                            {actionLoadingId === item?._id
                              ? "Please wait..."
                              : "Verify"}
                          </button>

                          <button
                            className="pv-btn hold"
                            onClick={handleHold}
                            disabled={actionLoadingId === item?._id}
                          >
                            Hold
                          </button>

                          <button
                            className="pv-btn reject"
                            onClick={() => handleReject(item)}
                            disabled={
                              actionLoadingId === item?._id || isApproved
                            }
                          >
                            Reject
                          </button>

                          <button
                            className="pv-btn delete"
                            onClick={handleDelete}
                            disabled={actionLoadingId === item?._id}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showVerifyModal && selectedItem && (
        <div className="pv-modal-overlay">
          <div className="pv-modal">
            <div className="pv-modal-head">
              <h3>Verify Payment</h3>
            </div>

            <div className="pv-modal-body">
              <div className="pv-info-grid">
                <div className="pv-info-card">
                  <div className="pv-info-label">Party</div>
                  <div className="pv-info-value">
                    {getPartyName(selectedItem)}
                  </div>
                </div>

                <div className="pv-info-card">
                  <div className="pv-info-label">Invoice No</div>
                  <div className="pv-info-value">
                    {selectedItem?.invoiceId || "-"}
                  </div>
                </div>

                <div className="pv-info-card">
                  <div className="pv-info-label">Scanned Date</div>
                  <div className="pv-info-value">
                    {getScannedDate(selectedItem)}
                  </div>
                </div>

                <div className="pv-info-card">
                  <div className="pv-info-label">Amount</div>
                  <div className="pv-info-value">
                    ₹{" "}
                    {Number(selectedItem?.paidAmounts || 0).toLocaleString(
                      "en-IN",
                    )}
                  </div>
                </div>

                <div className="pv-info-card">
                  <div className="pv-info-label">Account Number</div>
                  <div className="pv-info-value">
                    {selectedItem?.accountNumber || "-"}
                  </div>
                </div>

                <div className="pv-info-card">
                  <div className="pv-info-label">Bank IFSC</div>
                  <div className="pv-info-value">
                    {selectedItem?.bankIFSC || "-"}
                  </div>
                </div>
              </div>

              <label className="pv-label">
                Bank / Transaction / UTR Details
              </label>

              <textarea
                className="pv-textarea"
                value={verificationText}
                onChange={(e) => setVerificationText(e.target.value)}
                placeholder="Example: HDFC bank credited for Raj Store, UTR 123456789012, payment matched with invoice."
              />
            </div>

            <div className="pv-modal-foot">
              <button
                className="pv-btn pv-btn-light"
                onClick={closeVerifyModal}
              >
                Close
              </button>

              <button
                className="pv-btn verify"
                onClick={handleVerifySubmit}
                disabled={actionLoadingId === selectedItem?._id}
              >
                {actionLoadingId === selectedItem?._id
                  ? "Submitting..."
                  : "Save & Verify"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentVerification;
